module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/lim/lim.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/lim/lim.png
// module id = 586
// module chunks = 0